<template>
    <b-modal class="report-widget-details-modal"
             hide-footer
             :id="modalId"
             :title="$i18n.gt(widget.headingKey)">

        <div v-if="widget.indicatorLight" class="text-center">

            <report-widget-advice :score-name="widget.indicatorLight.scoreName">
            </report-widget-advice>

            <report-widget-resources :score-name="widget.indicatorLight.scoreName"
                                     v-if="$user.practitionerId()">
            </report-widget-resources>

        </div>
        <div v-else>

            <div v-for="(m,i) in widget.meters" :key="i" class="mb-3">

                <report-meter :score-name="m.scoreName"
                              :custom-gauge-colors="widget.customGaugeColors"
                              :label="getMeterLabel(m)">
                </report-meter>
                <div v-if="m.biometric">
                    <report-biometric-value :score-name="m.scoreName"
                                            :label-key="m.biometric.labelKey"
                                            :units="m.biometric.units"
                                            :precision="m.biometric.precision"/>
                </div>
                <div v-if="m.planScore">
                    <!-- show advice for an individual score -->
                    <report-widget-advice :score-name="m.planScore.scoreName">
                    </report-widget-advice>

                    <report-widget-goal :score-name="m.planScore.scoreName">
                    </report-widget-goal>

                    <report-widget-resources :score-name="m.planScore.scoreName"
                                             v-if="$user.practitionerId()">
                    </report-widget-resources>
                </div>
            </div>

            <div v-if="widget.summaryPlanScore" class="mt-5">
                <!-- show advice for a group of scores (e.g. SCORE_BP, SCORE_METAB) -->
                <report-widget-advice :score-name="widget.summaryPlanScore.scoreName">
                </report-widget-advice>

                <report-widget-goal :score-name="widget.summaryPlanScore.scoreName">
                </report-widget-goal>

                <report-widget-resources :score-name="widget.summaryPlanScore.scoreName"
                                         v-if="$user.practitionerId()">
                </report-widget-resources>
            </div>

        </div>

        <!-- show wbi breakdown -->
        <template v-if="widgetKey === 'WBI_SCORE'">
            <report-widget-wbi-breakdown :widget="widget"/>
        </template>

        <slot>
            <!-- show custom content here (e.g. for Framingham) -->
        </slot>

    </b-modal>

</template>

<!-- ----------------------------------------------------------------------- -->

<script>
    import Vue from 'vue'
    import * as _ from 'lodash'
    import ReportMixin from '@/providers/ReportMixin'
    import Utils from '@/providers/Utils'

    /**
     * Modal to display detailed information for an individual score - including indicator lights,
     * linear gauges, selected plan of care resources, and advice.
     */
    export default Vue.extend({
        name: 'ReportWidgetDetailsModal',
        mixins: [ReportMixin],
        props: {
            widgetKey: String,
        },
        computed: {
            widget() {
                return this.getWidgets()[this.widgetKey] // see ReportMixin
            },
            modalId() {
                return `modal_${this.widgetKey}`
            }
        },
    })
</script>

<!-- ----------------------------------------------------------------------- -->

<style lang="scss">

    .report-widget-details-modal {
    }

    #modal_WBI_SCORE___BV_modal_content_ {
        overflow-y: scroll;

    }

</style>
